<template>
  <div class="nv_down">
    <!-- 普通用户下载空白题 -->
    <adModel v-if="options.img" :options="options" :show="nvDownLoad" />
    <van-overlay v-else :show="nvDownLoad" class="downLoad_wrapper" :lock-scroll="false">
      <div class="down">
        <img
          class="download"
          src="https://img.yzcdn.cn/upload_files/2020/06/09/FuXmX-IGwPHwRsxVeS_fJMb3hyoq.png"
        />
        <div class="content">
          <div class="vip_title">会员专属特权</div>
          <div class="open">开通会员，可免费下载空白页</div>
          <div class="btn" @click="openVip">开通会员下载</div>
          <!--   <div class="x_title" @click="batchDownload">我是机构，想批量下载</div>-->
        </div>
        <!-- 关闭按钮 -->
        <div>
          <img
            class="close"
            src="https://img.yzcdn.cn/upload_files/2019/11/25/Fs53hUSGrw074xduGjRxvDIQSTYd.png"
            @click="close"
          />
        </div>
      </div>
      <!-- <div v-else class="down">
        <img class="download" :src="adImgsrc" @click="openVip" />
        <div>
          <img
            class="close"
            src="https://img.yzcdn.cn/upload_files/2019/11/25/Fs53hUSGrw074xduGjRxvDIQSTYd.png"

            @click="close"
          />
        </div>
      </div> -->
    </van-overlay>

    <!-- 下载空白题引导 -->
    <van-overlay :show="downloadGrde" class="downOverlay" :lock-scroll="false">
      <div class="down">
        <img
          class="download"
          src="https://img.yzcdn.cn/upload_files/2020/05/27/FmcuIYCCONYFz5HCrt_Iraar_AAm.gif"
        />
        <a @click="closeGrde()"></a>
      </div>
    </van-overlay>
    <!-- 会员机构用户 -->
    <van-overlay :show="showjg" class="downLoad_wrapper" :lock-scroll="false">
      <div class="down">
        <img
          class="download jgImg"
          src="https://img.yzcdn.cn/upload_files/2020/06/08/Fr_yxctJZvwGFjWACQd-3cU7kEFM.png"
        />
        <div class="content jg">
          <div class="vip_title">机构版套餐</div>
          <div class="open">可享受批量下载</div>
          <div class="btn jgtop" @click="batchDownload('sv')">我是机构，想批量下载</div>
        </div>
        <!-- 关闭按钮 -->
        <div>
          <img
            class="close"
            src="https://img.yzcdn.cn/upload_files/2019/11/25/Fs53hUSGrw074xduGjRxvDIQSTYd.png"
            @click="closejg"
          />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
// getformData,
import { Overlay } from 'vant'
import { adModel } from '../../../../../library'
import { delCookie, setCookie } from '@/static/js/zjs'
import { getMopaAd } from '@/api/ad'
export default {
  name: '',
  components: {
    [Overlay.name]: Overlay,
    adModel: adModel.component
  },

  props: {
    nvDownLoad: {
      default: false
    },
    showjg: {
      default: false
    },
    downloadGrde: {
      default: false
    }
  },
  data() {
    return {
      paySuccess: false,
      adImgsrc: null,
      adLinkto: null,
      options: {
        img: '',
        link: '',
        ad: false,
        close: () => {
          this.closeMj()
        }
      }
    }
  },
  async mounted() {
    await getMopaAd(
      {
        code: 'mjBook', // 页面
        cCodes: 'mjBook_downloadPage' // 页面位置
      },
      this.$store.userInfo.vipLevel.toUpperCase(),
      this.$env.isIos
    ).then((res) => {
      if (res.length > 0) {
        this.options.img = res[0].imgPath
        this.options.link = res[0].urlPath
        this.options.ad = res[0].externalOrg
      }
    })
  },
  methods: {
    closeMj() {
      this.$emit('close', false)
    },
    // openVip() {

    //   setCookie('answerUrl', window.location.hash)
    //   this.$trackevent({
    //     type: 'funcTracker',
    //     action: 'click',
    //     opt_label: '空白页下载-支付弹框'
    //   })
    //   this.$http
    //     .post(
    //       '/cms/weixin/user/order/create',
    //       getformData({
    //         openid: this.$store.openid,
    //         pkg: 'v_year',
    //         channel: 'svip_daanye_xiazaikongbaiye_gn'
    //       })
    //     )
    //     .then((res) => {
    //       if (res.data) {
    //         this.clearVip()
    //         window.wx.chooseWXPay({
    //           appId: res.data.appId,
    //           timestamp: res.data.timeStamp,
    //           nonceStr: res.data.nonceStr,
    //           package: res.data.wxpackage,
    //           signType: res.data.signType,
    //           paySign: res.data.paySign,
    //           success: function(res) {
    //             if (res.errMsg === 'chooseWXPay:ok') {
    //               window.location.href = '/cms/webapp/home/answer/index.html#/paySuccess'
    //               // window.location.replace('/cms/webapp/home/answer/index.html#/paySuccess');
    //               setCookie('gobcak', 'gobcak')
    //             } else {
    //               alert('支付失败:' + res.errMsg + '\n您可以重试或在客服留言咨询.')
    //             }
    //           },
    //           cancel: function() {}
    //         })
    //       }
    //     })
    // },
    openVip() {
      // 如果mopa有数据跳转mopa链接
      if (this.adImgsrc) {
        window.location.href = this.options.link
      } else {
        window.location.href = '/cms/webapp/home/vipPay/index.html#/sv'
      }
    },
    batchDownload(type) {
      window.location.href = 'https://mp.weixin.qq.com/s/gmDLUsnzg9e_cz-wOZjiGQ'
      if (type !== 'nv') {
        setCookie('jgAlert', true, 1)
      }
    },
    // 清除vip相关cookie
    clearVip() {
      delCookie('zijinUserVip')
      delCookie('userinfo')
    },
    close() {
      this.$emit('close', false)
    },
    closejg() {
      this.$emit('closejg', false)
    },
    closeGrde() {
      this.$emit('closeGrde', false)
    }
  }
}
</script>

<style lang="scss" scroped>
.downLoad_wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  .down {
    position: relative;
  }
  img {
    width: 7.49rem;
    &.jgImg {
      width: 7.52rem;
    }
  }

  .close {
    width: 0.75rem;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    padding-top: 0.53rem;
  }
  .content {
    width: 100%;
    position: absolute;
    text-align: center;
    top: 4.16rem;
    &.jg {
      top: 4.92rem;
    }
    .vip_title {
      color: #333333;
      font-size: 0.48rem;
    }
    .open {
      color: #999999;
      font-size: 0.37rem;
      margin-top: 0.25rem;
    }
    .btn {
      width: 5.41rem;
      height: 1.04rem;
      background: linear-gradient(90deg, rgba(255, 139, 62, 1), rgba(239, 66, 70, 1));
      border-radius: 1rem;
      font-size: 0.4rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 1.04rem;
      margin: 0 auto;
      margin-top: 0.88rem;
      &.jgtop {
        margin-top: 0.68rem;
      }
    }
    .x_title {
      font-size: 0.32rem;
      font-family: PingFang SC;
      font-weight: 400;
      text-decoration: underline;
      color: rgba(153, 153, 153, 1);
      margin-top: 0.43rem;
    }
  }
}
</style>
